// Gatsby supports TypeScript natively!
import React from 'react';

import { Link } from 'gatsby';
import { GiSatelliteCommunication, GiModernCity } from 'react-icons/gi';
import { MdPhone, MdMailOutline } from 'react-icons/md';
import { AiFillDatabase } from 'react-icons/ai';

import {
  FaLinkedin,
  FaTwitter,
  FaInstagram,
  FaYoutube,
  FaBlog,
  FaFacebook,
  FaNetworkWired,
} from 'react-icons/fa';
import Layout from '../components/layout';
import Section from '../components/Section';
import SEO from '../components/seo';
import Navbar from '../components/Navbar';
import Card from '../components/Card';

import Logo from '../images/e2ebranco.png';
import CpeIng from '../images/cpe.jpg';

import {
  HeroContainer,
  TopSection,
  FooterContainer,
} from '../styles/index.styles';

const BlogIndex = () => {
  return (
    <Layout>
      <SEO title="e2e Tecnologia" />
      <TopSection>
        <Navbar>
          <Link to="/">
            <img src={Logo} alt="Logo" />
          </Link>
          <div>
            <Link to="/about-us">Sobre nós</Link>
            <a href="mailto:comercial@e2etecnologia.com">Contato</a>
          </div>
        </Navbar>
        <HeroContainer>
          <p>
            Produtos, serviços e soluções de grande performance, tecnologias de
            ponta garantindo estabilidade em sua conexão
          </p>
        </HeroContainer>
      </TopSection>
      <Section title="Serviços">
        <Link to="/about-us#telecomunicacoes">
          <Card
            icon={FaNetworkWired}
            title="Telecomunicações"
            description="Serviços e soluções para o setor de Telecomunicações."
          />
        </Link>
        <Link to="/about-us#monitoramento">
          <Card
            icon={GiModernCity}
            title="Monitoramento e Safety city"
            description="Serviços e soluções para monitoramento,  sistemas de controle e segurança."
          />
        </Link>
        <Link to="/about-us#dataCenters">
          <Card
            icon={AiFillDatabase}
            title="Data Centers"
            description="Serviços e soluções na instalação dos ambientes."
          />
        </Link>
        <Link to="/about-us#fornecimento">
          <Card
            icon={GiSatelliteCommunication}
            title="Fornecimento de Recursos Técnicos"
            description="Fornecimento de Recursos para prestação de serviços técnicos e especializados de acordo com a necessidade do mercado"
          />
        </Link>
      </Section>
      {/* <Section title="Fabricantes" background="#0079BF">
        <p>Em breve nossos parceiros.</p>
      </Section> */}
      <Section title="Produtos">
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <img src={CpeIng} alt="Roteador" />
          <p style={{ fontWeight: 'lighter' }}>
            em breve todos nossos produtos
          </p>
        </div>
      </Section>
      <Section background="#002D55">
        <FooterContainer>
          <div>
            <h2>Contatos:</h2>
            <p>
              <MdPhone size={24} /> +55 11 98237-0878
            </p>
            <p>
              <a href="mailto:comercial@e2etecnologia.com">
                <MdMailOutline size={24} /> comercial@e2etecnologia.com
              </a>
            </p>
          </div>
          <div>
            <h2>Redes sociais:</h2>
            <p>
              <a href="https://www.instagram.com/e2etecnologia/">
                <FaInstagram size={24} color="#FFFFFF" />
              </a>
              <a href="https://twitter.com/e2etecnologia">
                <FaTwitter size={24} color="#FFFFFF" />
              </a>
              <a href="https://e2etecnologia.blogspot.com/">
                <FaBlog size={24} color="#FFFFFF" />
              </a>
            </p>
            <p>
              <a href="https://www.linkedin.com/company/e2etecnologia/">
                <FaLinkedin size={24} color="#FFFFFF" />
              </a>
              <a href="https://www.youtube.com/channel/UCeJrzRjBxGVAyIUgz2uIirQ">
                <FaYoutube size={24} color="#FFFFFF" />
              </a>
              <a href="https://www.facebook.com/E2ETecnologia/">
                <FaFacebook size={24} color="#FFFFFF" />
              </a>
            </p>
          </div>
        </FooterContainer>
      </Section>
    </Layout>
  );
};

export default BlogIndex;
